import { IStateParamsService } from 'angular-ui-router';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPageMr0169 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Mr0169Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    $stateParams: IStateParamsService,) {
    const vm: IPageMr0169 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            { nom: 'fppann', largeur: 90 },
            { nom: 'fppagelim', largeur: 120 },
            { nom: 'fppnbrjrsann', largeur: 158 },
            { nom: 'fppprcexe', largeur: 65 },
            { nom: 'fppprcfe', largeur: 65 },
            { nom: 'fppmntded', largeur: 65 },
            { nom: 'fppmntmaxadm', largeur: 120 },
            { nom: 'fppmntmaxexe', largeur: 120 },
            { nom: 'fppmntmaxfe', largeur: 120 }
        ], formulaire: new Formulaire([
            new FormulaireItem('fppann', {
                largeur: 33
            }),
            new FormulaireItem('fppagelim', {
                largeur: 33
            }),
            new FormulaireItem('fppnbrjrsann', {
                largeur: 33
            }),
            new FormulaireItem('fppprcexe', {
                largeur: 33
            }),
            new FormulaireItem('fppprcfe', {
                largeur: 33
            }),
            new FormulaireItem('fppmntded', {
                largeur: 33
            }),
            new FormulaireItem('fppmntmaxadm', {
                largeur: 33
            }),
            new FormulaireItem('fppmntmaxexe', {
                largeur: 33
            }),
            new FormulaireItem('fppmntmaxfe', {
                largeur: 33
            }),
            new FormulaireItem('fpncleint', {
                default: $stateParams.fpncleint
            })
        ])
    };
}
